import { CrudField } from "../CrudField";
import { BooleanProperty } from "../property-types";

export class BooleanField extends CrudField {
  public static fieldName = "BooleanField";
  public static formComponentName: string = "form-boolean-field";
  public static viewComponentName: string = "view-boolean-field";
  protected static readonly defaultPropertyType = BooleanProperty;
}
